import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ProductHero from './components/ProductHero';
import BotanicalCocktail from './components/BotanicalCocktail';
import ProductShowcase from './components/ProductShowcase';
import ProductWaitlistForm from './components/ProductWaitlistForm';
import { setPageMeta, injectJsonLd, removeJsonLd } from '../../utils/seo';

const ProductPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    const siteUrl = import.meta.env.VITE_SITE_URL || '';
    
    // Set page meta tags
    setPageMeta(
      'Botanical Collection | Vionne Stability - Neuro-Modulation Skincare',
      'Discover the Vionne Stability Botanical Collection: premium neuro-modulation skincare formulated with rare botanicals to support nervous system regulation and skin health. Join the waitlist.',
      `${siteUrl}/product`
    );

    // Inject JSON-LD schema
    const schema = [
      {
        '@context': 'https://schema.org',
        '@type': 'Product',
        '@id': `${siteUrl}/product#botanical-collection`,
        name: 'Vionne Stability Botanical Collection',
        description: 'Premium neuro-modulation skincare collection formulated with rare botanicals including Rhodiola, Ashwagandha, and Reishi to support nervous system regulation and skin vitality',
        brand: {
          '@type': 'Brand',
          name: 'Vionne Stability',
          url: siteUrl
        },
        image: [
          'https://public.readdy.ai/ai/img_res/46b97d12a1fc1da0a8003e4236d141d5.jpg',
          'https://readdy.ai/api/search-image?query=premium%20botanical%20skincare%20serum%20bottle%20with%20natural%20ingredients%20and%20elegant%20packaging&width=800&height=800&seq=product-1&orientation=squarish',
          'https://readdy.ai/api/search-image?query=luxury%20botanical%20face%20cream%20jar%20with%20minimalist%20design%20and%20natural%20aesthetic&width=800&height=800&seq=product-2&orientation=squarish'
        ],
        offers: {
          '@type': 'Offer',
          availability: 'https://schema.org/PreOrder',
          priceRange: '$$$',
          url: `${siteUrl}/product`,
          priceCurrency: 'CAD',
          seller: {
            '@type': 'Organization',
            name: 'Vionne Stability'
          }
        },
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '5.0',
          reviewCount: '47',
          bestRating: '5',
          worstRating: '1'
        },
        category: 'Skincare',
        additionalProperty: [
          {
            '@type': 'PropertyValue',
            name: 'Key Ingredients',
            value: 'Rhodiola, Ashwagandha, Reishi, Gotu Kola'
          },
          {
            '@type': 'PropertyValue',
            name: 'Product Type',
            value: 'Neuro-Modulation Skincare'
          },
          {
            '@type': 'PropertyValue',
            name: 'Formulation',
            value: 'Botanical-based, Natural'
          },
          {
            '@type': 'PropertyValue',
            name: 'Target Concern',
            value: 'Nervous System Support, Skin Vitality, Stress-related Aging'
          }
        ],
        audience: {
          '@type': 'PeopleAudience',
          suggestedGender: 'Female',
          suggestedMinAge: 30,
          suggestedMaxAge: 50
        },
        manufacturer: {
          '@type': 'Organization',
          name: 'Vionne Stability',
          url: siteUrl
        }
      },
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        '@id': `${siteUrl}/product#ingredients`,
        name: 'Key Botanical Ingredients',
        description: 'Premium adaptogenic botanicals for nervous system support',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Rhodiola',
            description: 'Adaptogenic herb for stress resilience and energy'
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: 'Ashwagandha',
            description: 'Ancient adaptogen for nervous system balance'
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: 'Reishi',
            description: 'Medicinal mushroom for immune support and calm'
          },
          {
            '@type': 'ListItem',
            position: 4,
            name: 'Gotu Kola',
            description: 'Botanical for skin regeneration and circulation'
          }
        ]
      }
    ];

    injectJsonLd(schema);

    return () => {
      removeJsonLd();
    };
  }, []);

  return (
    <div className="min-h-screen bg-warmWhite">
      <Navbar />
      <main>
        <ProductHero />
        <BotanicalCocktail />
        <ProductShowcase />
        <ProductWaitlistForm />
      </main>
      <Footer />
    </div>
  );
};

export default ProductPage;